module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "singlePost"
  }, [(!_vm.singleLoaded) ? _c('div', {
    staticClass: "singleLoaded"
  }, [_c('h1', {
    staticClass: "headerElement"
  }, [_vm._v("Loading")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "signlePostHeader",
    style: ({
      background: _vm.yearColor
    })
  }, [_c('span', {
    staticClass: "headerElement"
  }, [_vm._v("Work")]), _vm._v(" "), _c('span', {
    staticClass: "headerElement alignCenter"
  }, [_vm._v("Year"), _c('br', {
    staticClass: "tabletView"
  }), _vm._v(" " + _vm._s(_vm.year))]), _vm._v(" "), (_vm.showIndexFirst) ? _c('span', {
    staticClass: "headerElement alignRight"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Back")])]) : _c('span', {
    staticClass: "headerElement alignRight"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goBackNone()
      }
    }
  }, [_vm._v("Back")])])]), _vm._v(" "), (_vm.singleLoaded) ? _c('div', {
    staticClass: "postcontentWrapper",
    style: ({
      background: _vm.yearColor
    })
  }, [_c('div', {
    staticClass: "left",
    style: ({
      background: _vm.yearColor
    })
  }, [_c('p', {
    staticClass: "postcontentWrapperTitle"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonStudent)
    }
  }), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonTitle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notTabletView",
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonContentMedia)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right",
    style: ({
      background: _vm.yearColor
    })
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonContent)
    }
  }), _vm._v(" "), (_vm.postJsonThesis) ? _c('div', {
    staticClass: "attachments"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          Thesis:\n        ")]), _vm._v(" "), _c('ul', [(_vm.postJsonThesisUploaded) ? _c('li', [_c('span', {
    staticClass: "attachmentInner"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.postJsonThesisFile.url
    }
  }, [_vm._v("Download")])])]) : _c('li', [_c('span', {
    staticClass: "attachmentInner"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.postJsonThesisLink
    }
  }, [_vm._v("Download")])])])])]) : _vm._e(), _vm._v(" "), (_vm.postJsonAttachedField) ? _c('div', {
    staticClass: "attachments"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          Attachments:\n        ")]), _vm._v(" "), _c('ul', _vm._l((_vm.postJsonAttachedField), function(file) {
    return _c('li', [_c('span', {
      staticClass: "attachmentInner"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(file.prettytitle)
      }
    }), _vm._v(" "), _c('span', [_c('a', {
      attrs: {
        "href": file.attachments.url
      }
    }, [_vm._v("Download")])]), _vm._v(" "), _c('span', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(file.description)
      }
    })])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabletView paddedTop",
    domProps: {
      "innerHTML": _vm._s(_vm.postJsonContentMedia)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cbf1a1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/singlePost.vue
// module id = 54
// module chunks = 1